import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/usePublication'
import { useRelations } from '@hooks/usePublicationPaginationRule'

import type { PublicationPaginationRuleModel } from '@models/types'
import type { ListItemProps } from '@hooks/useSelectEntities'

interface PaginationRulePublicationListItemProps extends ListItemProps {
  publicationPaginationRule: PublicationPaginationRuleModel,
}

const PaginationRulePublicationListItem = (props: PaginationRulePublicationListItemProps) => {
  const { publicationPaginationRule, ...restProps } = props

  const { publication } = useRelations(publicationPaginationRule)
  const { id, title } = publication

  const { editPublicationUrl } = generateUrls(publication)

  return (
    <DashboardModuleListItem
      showCheckbox
      title={title}
      {...restProps}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>

      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={`${editPublicationUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default PaginationRulePublicationListItem
